module.exports = __webpack_public_path__ + "static/media/rituiBaransu.2cb13095.png";